/** 토스 앱 내부 WebView 감지 */
export function isTossApp(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent.includes("TossApp");
}
